import { jsx as _jsx } from "react/jsx-runtime";
import { Breadcrumbs } from "@air/component-breadcrumbs";
import { memo, useMemo } from "react";
export const BoardSuggestionBreadcrumbs = /*#__PURE__*/ memo((param)=>{
    let { ancestors } = param;
    const ancestorsItems = useMemo(()=>{
        const items = [];
        items.push(...ancestors.map((ancestor)=>({
                className: "text-inherit truncate font-normal px-0",
                id: ancestor.id,
                label: ancestor.title,
                type: "item"
            })));
        return items;
    }, [
        ancestors
    ]);
    return /*#__PURE__*/ _jsx(Breadcrumbs, {
        isCompact: true,
        className: "overflow-visible text-12 text-grey-11",
        items: ancestorsItems
    });
});
BoardSuggestionBreadcrumbs.displayName = "BoardSuggestionBreadcrumbs";
